import { render, staticRenderFns } from "./2dSetting.vue?vue&type=template&id=0f2cdfa2&scoped=true&"
import script from "./2dSetting.vue?vue&type=script&lang=js&"
export * from "./2dSetting.vue?vue&type=script&lang=js&"
import style0 from "./2dSetting.vue?vue&type=style&index=0&id=0f2cdfa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cdfa2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VColorPicker,VDialog,VIcon,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2cdfa2')) {
      api.createRecord('0f2cdfa2', component.options)
    } else {
      api.reload('0f2cdfa2', component.options)
    }
    module.hot.accept("./2dSetting.vue?vue&type=template&id=0f2cdfa2&scoped=true&", function () {
      api.rerender('0f2cdfa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/2dSetting.vue"
export default component.exports